import {
  DocumentUploadCardItem,
  DocumentUploadCardUpload,
} from '../card/document-upload-card/document-upload-card.types';
import {
  ProviderDocumentAnalysisStatus,
  ProviderDocumentResponse,
  ProviderDocumentType,
  ProviderDocumentVisibility,
} from '@frontend/shared-api';

export const EXTRACTION_POLL_INTERVAL_MS = 5000;

export const DOCUMENT_TYPE_ORDER: ProviderDocumentType[] = [
  ProviderDocumentType.DATA_SHEET,
  ProviderDocumentType.WHITEPAPER,
  ProviderDocumentType.SECURITY_REPORT,
  ProviderDocumentType.CASE_STUDY,
  ProviderDocumentType.MANUAL,
  ProviderDocumentType.OTHER,
];

export const VISIBILITY_ORDER: ProviderDocumentVisibility[] = [
  ProviderDocumentVisibility.PUBLIC,
  ProviderDocumentVisibility.CONFIDENTIAL,
];

export const VISIBILITY_RANK: Record<ProviderDocumentVisibility, number> = {
  [ProviderDocumentVisibility.CONFIDENTIAL]: 0,
  [ProviderDocumentVisibility.PUBLIC]: 1,
};

export type TagSeverity = 'secondary' | 'info' | 'success' | 'danger';

export const ANALYSIS_STATUS_SEVERITY: Record<ProviderDocumentAnalysisStatus, TagSeverity> = {
  [ProviderDocumentAnalysisStatus.PENDING]: 'secondary',
  [ProviderDocumentAnalysisStatus.EXTRACTING]: 'info',
  [ProviderDocumentAnalysisStatus.READY]: 'success',
  [ProviderDocumentAnalysisStatus.FAILED]: 'danger',
};

export interface LabeledOption<T> {
  label: string;
  value: T;
}

export interface DocumentRow {
  document: ProviderDocumentResponse;
  item: DocumentUploadCardItem;
  toolNames: string[];
  superseded: boolean;
  statusSeverity: TagSeverity;
  extractionPercent: number | null;
  retryable: boolean;
}

export interface DocumentGroup {
  type: ProviderDocumentType;
  labelKey: string;
  items: DocumentUploadCardItem[];
  activeCount: number;
}

export interface ProjectReferenceRow {
  item: DocumentUploadCardItem;
  toolName: string;
  projectName: string;
  companyName: string;
}

export interface PendingUpload {
  documentType: ProviderDocumentType;
  upload: DocumentUploadCardUpload;
}

export type ToolAssignmentDialog =
  | {kind: 'upload'; pendingUpload: PendingUpload}
  | {kind: 'assign'; document: ProviderDocumentResponse};
